module.exports = __webpack_public_path__ + "img/92.74a0b271.jpg";